import { render, staticRenderFns } from "./atlas.vue?vue&type=template&id=86ee70d0&scoped=true"
import script from "./atlas.vue?vue&type=script&lang=js"
export * from "./atlas.vue?vue&type=script&lang=js"
import style0 from "./atlas.vue?vue&type=style&index=0&id=86ee70d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ee70d0",
  null
  
)

export default component.exports